/**
 * Shared card palette for the public portal's service grids.
 *
 * The Key Services and Citizen Services grids each carried their own list of
 * bright hues — eleven and eight respectively, running through amber, crimson,
 * pink, purple and cyan. Side by side on one page that reads as a novelty
 * dashboard rather than a government directorate, and several of the lighter
 * tones (#F57F17, #FFB300) failed contrast when used as CTA text on white.
 *
 * This is one curated set for both grids: six deep, mid-saturation tones that
 * sit together without competing. Every `from` value clears 4.5:1 on white, so
 * it is safe as body-weight text, and every pair carries white text at AA when
 * used as a card fill.
 *
 * Index 0 is the department's own saffron, so the first — and most prominent —
 * card in any grid is always on brand.
 */
export const CARD_ACCENTS: [string, string][] = [
  ['#C2551F', '#E8833C'], // saffron / clay — the DTCP mark
  ['#2A4A7B', '#4A72AB'], // indigo
  ['#256D4A', '#3E9B6D'], // forest
  ['#14615F', '#23918C'], // teal
  ['#4A3A6B', '#6E58A0'], // plum
  ['#3A4A57', '#5A7183'], // slate
];

/** The [from, to] pair for card `i`, cycling through the palette. */
export const cardAccent = (i: number): [string, string] =>
  CARD_ACCENTS[i % CARD_ACCENTS.length];
